/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * dashboard API Specification
 * OpenAPI spec version: 0.0.7
 */
import { useMutation, useQuery } from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType,
} from '@tanstack/vue-query';

import { unref } from 'vue';
import type { MaybeRef } from 'vue';

import type {
  GnbResponse,
  IntegrateDashboardAnalysisPatchRequestBody,
  IntegrateDashboardGnbPatchRequestBody,
  SuccessResponse,
} from '../../model';

import { customAxiosInstance } from '../../../../common/api/utils/mutator';
import type { ErrorType, BodyType } from '../../../../common/api/utils/mutator';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary getAllMenu
 */
export const getV7MenuPath = (
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  return customAxiosInstance<GnbResponse>(
    { url: `/api/v7/menu-path`, method: 'GET', signal },
    options,
  );
};

export const getGetV7MenuPathQueryKey = () => {
  return ['api', 'v7', 'menu-path'] as const;
};

export const getGetV7MenuPathQueryOptions = <
  TData = Awaited<ReturnType<typeof getV7MenuPath>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MenuPath>>, TError, TData>>;
  request?: SecondParameter<typeof customAxiosInstance>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = getGetV7MenuPathQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getV7MenuPath>>> = ({ signal }) =>
    getV7MenuPath(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getV7MenuPath>>,
    TError,
    TData
  >;
};

export type GetV7MenuPathQueryResult = NonNullable<Awaited<ReturnType<typeof getV7MenuPath>>>;
export type GetV7MenuPathQueryError = ErrorType<unknown>;

/**
 * @summary getAllMenu
 */

export function useGetV7MenuPath<
  TData = Awaited<ReturnType<typeof getV7MenuPath>>,
  TError = ErrorType<unknown>,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getV7MenuPath>>, TError, TData>>;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetV7MenuPathQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}

/**
 * @summary 대시보드 분석 메뉴 등록
 */
export const postV7MenuPathAnalysis = (
  integrateDashboardAnalysisPatchRequestBody: MaybeRef<IntegrateDashboardAnalysisPatchRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateDashboardAnalysisPatchRequestBody = unref(integrateDashboardAnalysisPatchRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/menu-path/analysis`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardAnalysisPatchRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV7MenuPathAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7MenuPathAnalysis>>,
    TError,
    { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7MenuPathAnalysis>>,
  TError,
  { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
  TContext
> => {
  const mutationKey = ['postV7MenuPathAnalysis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7MenuPathAnalysis>>,
    { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7MenuPathAnalysis(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7MenuPathAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7MenuPathAnalysis>>
>;
export type PostV7MenuPathAnalysisMutationBody =
  BodyType<IntegrateDashboardAnalysisPatchRequestBody>;
export type PostV7MenuPathAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 분석 메뉴 등록
 */
export const usePostV7MenuPathAnalysis = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7MenuPathAnalysis>>,
      TError,
      { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7MenuPathAnalysis>>,
  TError,
  { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV7MenuPathAnalysisMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 분석 메뉴 등록 취소
 */
export const patchV7MenuPathAnalysis = (
  integrateDashboardAnalysisPatchRequestBody: MaybeRef<IntegrateDashboardAnalysisPatchRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  integrateDashboardAnalysisPatchRequestBody = unref(integrateDashboardAnalysisPatchRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/menu-path/analysis`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardAnalysisPatchRequestBody,
    },
    options,
  );
};

export const getPatchV7MenuPathAnalysisMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>,
    TError,
    { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>,
  TError,
  { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
  TContext
> => {
  const mutationKey = ['patchV7MenuPathAnalysis'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>,
    { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV7MenuPathAnalysis(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7MenuPathAnalysisMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>
>;
export type PatchV7MenuPathAnalysisMutationBody =
  BodyType<IntegrateDashboardAnalysisPatchRequestBody>;
export type PatchV7MenuPathAnalysisMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 분석 메뉴 등록 취소
 */
export const usePatchV7MenuPathAnalysis = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>,
      TError,
      { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7MenuPathAnalysis>>,
  TError,
  { data: BodyType<IntegrateDashboardAnalysisPatchRequestBody> },
  TContext
> => {
  const mutationOptions = getPatchV7MenuPathAnalysisMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 메뉴 등록
 */
export const postV7MenuPathDashboard = (
  integrateDashboardGnbPatchRequestBody: MaybeRef<IntegrateDashboardGnbPatchRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
  signal?: AbortSignal,
) => {
  integrateDashboardGnbPatchRequestBody = unref(integrateDashboardGnbPatchRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/menu-path/dashboard`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardGnbPatchRequestBody,
      signal,
    },
    options,
  );
};

export const getPostV7MenuPathDashboardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postV7MenuPathDashboard>>,
    TError,
    { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postV7MenuPathDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
  TContext
> => {
  const mutationKey = ['postV7MenuPathDashboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postV7MenuPathDashboard>>,
    { data: BodyType<IntegrateDashboardGnbPatchRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return postV7MenuPathDashboard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostV7MenuPathDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof postV7MenuPathDashboard>>
>;
export type PostV7MenuPathDashboardMutationBody = BodyType<IntegrateDashboardGnbPatchRequestBody>;
export type PostV7MenuPathDashboardMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 메뉴 등록
 */
export const usePostV7MenuPathDashboard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postV7MenuPathDashboard>>,
      TError,
      { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof postV7MenuPathDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
  TContext
> => {
  const mutationOptions = getPostV7MenuPathDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary 대시보드 메뉴 등록 취소
 */
export const patchV7MenuPathDashboard = (
  integrateDashboardGnbPatchRequestBody: MaybeRef<IntegrateDashboardGnbPatchRequestBody>,
  options?: SecondParameter<typeof customAxiosInstance>,
) => {
  integrateDashboardGnbPatchRequestBody = unref(integrateDashboardGnbPatchRequestBody);

  return customAxiosInstance<SuccessResponse>(
    {
      url: `/api/v7/menu-path/dashboard`,
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      data: integrateDashboardGnbPatchRequestBody,
    },
    options,
  );
};

export const getPatchV7MenuPathDashboardMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof patchV7MenuPathDashboard>>,
    TError,
    { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
    TContext
  >;
  request?: SecondParameter<typeof customAxiosInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof patchV7MenuPathDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
  TContext
> => {
  const mutationKey = ['patchV7MenuPathDashboard'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof patchV7MenuPathDashboard>>,
    { data: BodyType<IntegrateDashboardGnbPatchRequestBody> }
  > = (props) => {
    const { data } = props ?? {};

    return patchV7MenuPathDashboard(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PatchV7MenuPathDashboardMutationResult = NonNullable<
  Awaited<ReturnType<typeof patchV7MenuPathDashboard>>
>;
export type PatchV7MenuPathDashboardMutationBody = BodyType<IntegrateDashboardGnbPatchRequestBody>;
export type PatchV7MenuPathDashboardMutationError = ErrorType<unknown>;

/**
 * @summary 대시보드 메뉴 등록 취소
 */
export const usePatchV7MenuPathDashboard = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof patchV7MenuPathDashboard>>,
      TError,
      { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
      TContext
    >;
    request?: SecondParameter<typeof customAxiosInstance>;
  },
  queryClient?: QueryClient,
): UseMutationReturnType<
  Awaited<ReturnType<typeof patchV7MenuPathDashboard>>,
  TError,
  { data: BodyType<IntegrateDashboardGnbPatchRequestBody> },
  TContext
> => {
  const mutationOptions = getPatchV7MenuPathDashboardMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
